import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import { createPinia, PiniaVuePlugin } from 'pinia'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import globalMixins from './mixin/globals'
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ko";
import Slick from 'vue-slick';
import VueMeta from 'vue-meta';

Vue.mixin({
  created() {
    dayjs.extend(relativeTime);
    dayjs.locale("ko");
    this.$dayjs = dayjs;
  }
})

Vue.use(globalMixins)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Slick)
Vue.use(VueMeta, { refreshOnceOnNavigation: true })

Vue.config.productionTip = false

const pinia = createPinia()
Vue.use(pinia)

const app = new Vue({
  router: router,
  render: h => h(App),
  pinia,
}).$mount('#app')

// prerender 트리거 — vue-meta가 라우트별 메타를 head에 주입한 직후 발화
router.onReady(() => {
  app.$nextTick(() => {
    document.dispatchEvent(new Event('render-event'))
  })
})
